import IdentificationMixin from './IdentificationMixin'

export default {
    mixins: [
        IdentificationMixin
    ]
}